<myre-modal-wrapper />
<myre-ui-cookies-banner
  [frontUserUrl]="_dynamicEnvService.env.myre.user.front.host"
  [domain]="_dynamicEnvService.env.domain"
  [cookieSuffix]="_dynamicEnvService.env.cookieSuffix"
/>

<router-outlet />

<myre-footer
  [logoPath]="'assets/images/myre-logo.svg'"
  [isAuth]="_authService.isAuth"
/>
